import '../Footer/Footer.css'

const Footer = () => {

    return (
        <footer className="Footer">Todos los derechos reservados</footer>
    )
}

export default Footer